import React, { useMemo } from "react";
import DelayedFreeze from "common/Home/MobileHome/DelayedFreeze.tsx";
import { matchPath, useLocation } from "react-router-dom";
import styled from "styled-components";
import { PAGES_DATA } from "common/Home/General/PagesData.tsx";
import SuspenseLoading from "common/Home/General/SuspenseLoading.tsx";

const BottomNavigatorPages = () => {
  const location = useLocation();

  const testPath = (path: string | string[], exact = false) =>
    !!matchPath(location.pathname, {
      path,
      exact,
      strict: false,
    });

  const screenToDisplay = useMemo(() => {
    return MOBILE_PAGES_DATA.map((item) => {
      const isExcludePath = !!item.excludePaths && testPath(item.excludePaths);
      return {
        ...item,
        shouldDisplay: testPath(item.path) && !isExcludePath,
        freeze: !testPath(item.path, true),
      };
    });
  }, [location.pathname]);

  return useMemo(() => {
    return (
      <MobileWrapper>
        {screenToDisplay.map((item) => {
          const OriginalComponent = item.component;
          return (
            <Wrapper $shouldDisplay={item.shouldDisplay} key={item.key}>
              <DelayedFreeze active={!item.freeze}>
                <SuspenseLoading>
                  <OriginalComponent key={item.key} />
                </SuspenseLoading>
              </DelayedFreeze>
            </Wrapper>
          );
        })}
      </MobileWrapper>
    );
  }, [screenToDisplay]);
};

export default BottomNavigatorPages;

const MOBILE_PAGES_DATA = Object.entries(PAGES_DATA)
  .filter(([_, pageData]) => pageData.isBottomNavigatorScreen)
  .map(([pageKey, pageData]) => ({ ...pageData, key: pageKey }));

// The layer itself never takes taps (it can sit over a page like onboarding
// when no bottom-navigator screen is shown); the visible screen opts back in.
const MobileWrapper = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  pointer-events: none;
`;
const Wrapper = styled.div<{ $shouldDisplay?: boolean }>`
  position: absolute;
  top: 0;
  opacity: ${(p) => (p.$shouldDisplay ? 1 : 0)};
  pointer-events: ${(p) => (p.$shouldDisplay ? "auto" : "none")};
  width: 100%;
  height: 100%;
`;
